export const MEMBER_EXCLUSIVES_URL = '/member-exclusives';
export const MEMBER_EXCLUSIVES_PAGE_TITLE = 'MEMBER EXCLUSIVES';
export const MEMBER_EXCLUSIVES_DESCRIPTION = 'There are lots of advantages of being a Living Rewards Member. Aside from the great points earning, there are other member exclusives that might interest you.';
export const REGEX_TO_REMOVE_HTML_TAGS = /(<([^>]+)>)/gi;
export const REGEX_TO_VALID_URLS = /(((https?:\/\/)|(www\.))[^\s]+)/g;